import React from "react";
import { useSelector } from "react-redux";
import { selectFillSources, selectLevelControls } from "../../../redux/selectors";

const PrintLevelControls = () => {
  const levelControlDetails = useSelector(selectLevelControls);
  const fillSourceDetails = useSelector(selectFillSources);

  const hasLevelControls = levelControlDetails?.some(detail => detail.HasLevelControls);

  if (!hasLevelControls) {
    return null;
  }

  const isZoneEmpty = (detail) => {
    return (
      !detail.LevelSensingMethod &&
      !detail.NumberOfSetPoints &&
      !detail.SensorLocation &&
      !detail.Comments
    );
  };

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    const groupedDetails = details.reduce((acc, detail) => {
      if (!acc[detail.Zone]) {
        acc[detail.Zone] = [];
      }
      acc[detail.Zone].push(detail);
      return acc;
    }, {});

    return (
      <div>
        {Object.keys(groupedDetails).map((zone, index) => {
          const zoneDetails = groupedDetails[zone];
          const fillSources = fillSourceDetails.filter(source => String(source.Zone) === zone);

          if (zoneDetails.every(detail => isZoneEmpty(detail)) && fillSources.length === 0) {
            return null;
          }

          return (
            <div className="section" key={index}>
              <h3 className="print-zone-label">Zone: {zone}</h3>
              <table className="table table-bordered full-width">
                <tbody>
                  {zoneDetails.map((detail, idx) => {
                    if (isZoneEmpty(detail)) {
                      return null;
                    }
                    return (
                      <tr key={idx}>
                        <td className="col-md-6">
                          <table>
                            <tbody>
                              <tr><td><strong>Level Sensing Method: </strong>{detail.LevelSensingMethod}</td></tr>
                              <tr><td><strong>Number Of Set Points: </strong>{detail.NumberOfSetPoints}</td></tr>
                              <tr><td><strong>Sensor Location: </strong>{detail.SensorLocation}</td></tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {fillSources.length > 0 && (
                <>
                  <h4 className="text-center">Pond Fill Logic</h4>
                  <table className="table table-bordered full-width">
                    <thead>
                      <tr>
                        <th>Fill Source</th>
                        <th>Type</th>
                        <th>HOA</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fillSources.map((source, idx) => (
                        <tr key={idx}>
                          <td>{source.FillSource}</td>
                          <td>{source.Type}</td>
                          <td>{source.HOA}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
              <p><strong>Comments:</strong><br />{zoneDetails[0]?.Comments}</p>
              <br className="clearfix" />
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      <h2 className="print-section-header">Level Controls Summary</h2>
      {renderDetails(levelControlDetails)}
    </div>
  );
};

export default PrintLevelControls;
